<template>
    <div class="banner" :style="{ 'backgroundImage':'url('+ url +')' }">
      <div class="font"><p>{{title}}</p></div>
    </div>
</template>

<script>
export default {
  name: 'index',
  props:['url','title']
}
</script>
<style lang="scss" scoped>
    .banner{
      width: 100%;
      height: 140px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .font{
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        position: relative;
        p{
          position: absolute;
          width: 164px;
          height: 88px;
          background: linear-gradient(top, #1B66A6 0%, #36B3DB 100%);
          bottom: 0;
          left: 0;
          border-top-left-radius: 40px;
          font-size: 24px;
          line-height: 88px;
          text-align: center;
          color: #fff;
          font-weight: bold;
        }
      }
    }
    @media screen and (max-width: 1200px){
      .banner{
        height: 88px;
        .font{
          width: 100%;
          box-sizing: border-box;
          padding: 0 24px;
          background-color: rgba(0,0,0,.2);
          p{
            position: static;
            text-align: center;
            width: 100%;
            background: none;
          }
        }
      }
       
    }
</style>





// WEBPACK FOOTER //
// src/components/PageBanner.vue